import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from './apiClient.js';

export const hrApi = {
  /* Die Woche als Raster - jeder Tag, auch der ohne Eintrag. */
  timeWeek:         (params) => apiGet('/api/hr/time-entries/week', params),
  updateTimeEntry:  (id, body) => apiPatch(`/api/hr/time-entries/${id}`, body),
  workSchedule:     (employeeId) => apiGet(`/api/hr/employees/${employeeId}/schedule`),
  setWorkSchedule:  (employeeId, body) => apiPut(`/api/hr/employees/${employeeId}/schedule`, body),
  listEmployees:    (params) => apiGet('/api/hr/employees', params),
  createEmployee:   (body)   => apiPost('/api/hr/employees', body),
  terminateEmployee:(id, body) => apiPost(`/api/hr/employees/${id}/terminate`, body),
  updateEmployee:   (id, body) => apiPut(`/api/hr/employees/${id}`, body),

  /* Die Verbindung zwischen Anmeldekonto und Personalakte. Ohne sie ist die
     gesamte Selbstbedienung tot: /api/hr/me antwortet mit 403, und wer seine
     eigene Zeit erfassen will, sieht nur einen Hinweis. Die Route gab es im
     Dienst von Anfang an - hier fehlte der Aufruf, und damit gab es in der
     ganzen Oberflaeche keinen Weg dorthin.
     userId === null loest die Verknuepfung wieder. */
  setUserLink:      (id, userId) => apiPut(`/api/hr/employees/${id}/user`, { userId }),

  /* Die Einstellungen der Firma zum Personalwesen. Lesen darf, wer 'hr'
     lesen darf; aendern nur die Firmenadministration - das setzt der Dienst
     durch, nicht diese Zeile. */
  einstellungen:    ()     => apiGet('/api/hr/settings').then((r) => r.items),
  setzeEinstellungen: (body) => apiPut('/api/hr/settings', body),
  listDepartments:  ()       => apiGet('/api/hr/departments'),
  listPositions:    (params) => apiGet('/api/hr/positions', params),
  listLeaveTypes:   ()       => apiGet('/api/hr/leave-types'),
  /* Gibt { items, meta } zurück - meta trägt seit Paket 11 die ECHTE
     Gesamtzahl und die Kennzahlen über alle Zeilen, nicht über die
     geladene Seite. */
  listLeaveRequests:(params) => apiGet('/api/hr/leave-requests', params),
  submitLeave:      (body)   => apiPost('/api/hr/leave-requests', body),
  decideLeave:      (id, decision, decisionNote = null) => apiPost(`/api/hr/leave-requests/${id}/decision`, { decision, decisionNote }),
  listLeaveBalances:(params) => apiGet('/api/hr/leave-balances', params),
  setEntitlement:   (body)   => apiPost('/api/hr/leave-balances', body),
  /* Der Jahresabschluss: erst sehen, dann tun. Ohne ihn verschwanden
     Restferien am 1. Januar. */
  yearClosePreview: (params) => apiGet('/api/hr/leave/year-close/preview', params),
  yearClose:        (body)   => apiPost('/api/hr/leave/year-close', body),
  listHolidays:     (params) => apiGet('/api/hr/holidays', params),
  /* Pflege der Feiertage. Die Tabelle war bis 2031 gefüllt - ab dem
     1. Januar 2032 hätte jeder Feiertag wieder einen Ferientag gekostet. */
  createHoliday:    (body)   => apiPost('/api/hr/holidays', body),
  updateHoliday:    (id, body) => apiPatch(`/api/hr/holidays/${id}`, body),
  deleteHoliday:    (id)     => apiDelete(`/api/hr/holidays/${id}`),
  /* Auch die stillgelegten Arten - für die Pflege, nicht für die Auswahl. */
  listAllLeaveTypes:()       => apiGet('/api/hr/leave-types/all'),
  createLeaveType:  (body)   => apiPost('/api/hr/leave-types', body),
  updateLeaveType:  (id, body) => apiPatch(`/api/hr/leave-types/${id}`, body),
  deleteLeaveType:  (id)     => apiDelete(`/api/hr/leave-types/${id}`),
  listCompanyEvents:  (params) => apiGet('/api/hr/company-events', params),
  createCompanyEvent: (body)   => apiPost('/api/hr/company-events', body),
  deleteCompanyEvent: (id)     => apiDelete(`/api/hr/company-events/${id}`),
  leaveCalendar:    (params) => apiGet('/api/hr/leave-calendar', params),
  /* Ein Monat in einem Aufruf: Abwesenheiten, Feiertage und Anlässe.
     Vorher lud die Kalenderseite ALLE jemals genehmigten Abwesenheiten. */
  leaveCalendarMonth: (params) => apiGet('/api/hr/leave-calendar/month', params).then((r) => r.items),
  listPayrollRuns:  (params) => apiGet('/api/hr/payroll/runs', params),
  getPayrollRun:    (id)     => apiGet(`/api/hr/payroll/runs/${id}`),
  getPayslip:       (id)     => apiGet(`/api/hr/payroll/payslips/${id}`),
  createPayrollRun: (body)   => apiPost('/api/hr/payroll/runs', body),

  // Travel expense reports (Reisekostenabrechnung)
  listTravelReports: (params) => apiGet('/api/hr/travel-reports', params),
  getTravelReport:   (id)     => apiGet(`/api/hr/travel-reports/${id}`),
  createTravelReport:(body)   => apiPost('/api/hr/travel-reports', body),
  submitTravelReport:(id)     => apiPatch(`/api/hr/travel-reports/${id}/submit`),
  approveTravelReport:(id)    => apiPatch(`/api/hr/travel-reports/${id}/approve`),
  rejectTravelReport:(id)     => apiPatch(`/api/hr/travel-reports/${id}/reject`),
  reimburseTravelReport:(id)  => apiPatch(`/api/hr/travel-reports/${id}/reimburse`),

  // Performance reviews
  listReviews:      (params) => apiGet('/api/hr/reviews', params),
  getReview:        (id)     => apiGet(`/api/hr/reviews/${id}`),
  createReview:     (body)   => apiPost('/api/hr/reviews', body),
  submitReview:     (id)     => apiPatch(`/api/hr/reviews/${id}/submit`),
  acknowledgeReview:(id)     => apiPatch(`/api/hr/reviews/${id}/acknowledge`),

  // Time tracking (Zeiterfassung)
  listTimeEntries:  (params) => apiGet('/api/hr/time-entries', params),
  createTimeEntry:  (body)   => apiPost('/api/hr/time-entries', body),
  deleteTimeEntry:  (id)     => apiDelete(`/api/hr/time-entries/${id}`),
  timeSummary:      (params) => apiGet('/api/hr/time-summary', params),
  /* Das Stundenkonto EINER Person. Ein einzelnes Objekt, deshalb .items -
     apiGet verpackt auch das, was gar keine Liste ist. */
  timeAccount:      (employeeId) => apiGet('/api/hr/time-account', { employeeId }).then((r) => r.items),

  // Recruitment
  listJobPostings:  (params) => apiGet('/api/hr/job-postings', params),
  createJobPosting: (body)   => apiPost('/api/hr/job-postings', body),
  setJobPostingStatus: (id, status) => apiPatch(`/api/hr/job-postings/${id}/status`, { status }),
  listCandidates:   ()       => apiGet('/api/hr/candidates'),
  createCandidate:  (body)   => apiPost('/api/hr/candidates', body),
  listApplications: (params) => apiGet('/api/hr/applications', params),
  submitApplication:(body)   => apiPost('/api/hr/applications', body),
  updateApplication:(id, body) => apiPatch(`/api/hr/applications/${id}`, body),

  // Analytics (charts)
  headcountByDepartment: ()       => apiGet('/api/hr/reports/headcount-by-department'),
  employeeStatus:        ()       => apiGet('/api/hr/reports/employee-status'),
  payrollTrend:          (params) => apiGet('/api/hr/reports/payroll-trend', params),
  recruitmentFunnel:     ()       => apiGet('/api/hr/reports/recruitment-funnel'),

  /* Quellensteuertarife. Erst sehen, dann uebernehmen - eine falsch gelesene
     Tarifdatei zieht jedem Betroffenen monatlich den falschen Betrag ab. */
  listFamilyAllowances: () => apiGet('/api/hr/payroll/family-allowances'),
  setFamilyAllowance: (body) => apiPost('/api/hr/payroll/family-allowances', body),
  listWithholdingTariffs: () => apiGet('/api/hr/payroll/withholding-tax/tariffs'),
  previewWithholdingTariffs: (body) => apiPost('/api/hr/payroll/withholding-tax/preview', body),
  importWithholdingTariffs: (body) => apiPost('/api/hr/payroll/withholding-tax/import', body),
  /* Ein Lohnlauf wird zurueckgenommen, nicht geloescht. */
  cancelPayrollRun: (id, reason) => apiPost(`/api/hr/payroll/runs/${id}/cancel`, { reason }),
};
